<template>
  <div style="height:200px">
    <div>
      <center style="height:1500px;">
        <h1 style>Admin Panel</h1>

        <h3 class="mt-2 font-semibold" style="color:#24388F;">
          Total KYC verified users: {{ userCount }}
        </h3>
        <div v-if="isOwner" class=" p-3 mx-auto">
          <div class="col-12 col-sm-8 card  p-4">
            <center>
              <h4>Add/Remove an Admin</h4>

              <div class="row justify-content-center">
                <div class="col-md-6 justify-center">
                  <form>
                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Tron address
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model="adminAddress1"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.adminAddress1.$error,
                        }"
                        type="text"
                      />
                      <div
                        v-if="submitted && $v.adminAddress1.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.adminAddress1.required"
                          >Address is required</span
                        >
                        <span v-if="!$v.adminAddress1.validAddress"
                          >Enter valid address</span
                        >
                      </div>
                    </div>
                    <div @click="addAdmin" class="btn btn-primary mb-2">
                      Add
                    </div>
                  </form>
                </div>

                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Tron address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="adminAddress2"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                  <div @click="removeAdmin" class="btn btn-primary">Remove</div>
                </div>
              </div>

              <!-- <div class="col-md-6 justify-center">
                <div class="btn btn-primary">Add</div>
              </div>-->
            </center>
            <hr style="border:0.5px solid blue;" />
            <center>
              <h4>Update Mima token price</h4>
              <div class="row justify-content-center">
                <div class="col-md-6 justify-center">
                  <div>
                    <h4 style="top:50px;">
                      Current Mima token price
                    </h4>
                    <h5>{{ price }} $(USD)</h5>
                  </div>
                </div>
                <div class="col-md-6 justify-center">
                  <form>
                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Enter token price in $(USD)
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model="tokenPrice"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.adminAddress1.$error,
                        }"
                        type="text"
                      />
                      <div
                        v-if="submitted && $v.adminAddress1.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.adminAddress1.required"
                          >Address is required</span
                        >
                        <span v-if="!$v.adminAddress1.validAddress"
                          >Enter valid address</span
                        >
                      </div>
                    </div>
                    <div @click="updatePrice" class="btn btn-primary mb-2">
                      Add
                    </div>
                  </form>
                </div>
              </div>
            </center>
            <hr style="border:0.5px solid blue;" />
            <center>
              <h4>Add a party</h4>

              <div class="row justify-center">
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Tron address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="partyAddress"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Party name
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="partyName"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-md-6 justify-content-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Email address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="partyEmail"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="partyDetails.address"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      City
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="partyDetails.city"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Zip code
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="partyDetails.zipCode"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Country
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="partyDetails.country"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Select Party type
                      <span class="text-danger">*</span>
                    </label>
                    <select class="form-control" v-model="partyType">
                      <option value disabled selected
                        >Choose your option</option
                      >
                      <option
                        :value="data"
                        v-for="(data, index) in selection"
                        :key="index"
                        >{{ data }}</option
                      >
                    </select>
                  </div>
                </div>
              </div>
              <center>
                <div class="col-md-6 justify-content-center">
                  <div @click="addParty" class="btn btn-primary">Add</div>
                </div>
              </center>
            </center>
            <hr style="border:0.5px solid blue;" />

            <center>
              <h4>Remove a party / Add special status</h4>

              <div class="row justify-center">
                <div class="col-md-12 justify-center">
                  <div
                    v-if="parties.length > 0"
                    class="row justify-content-center"
                  >
                    <div class="col-md-12 col-lg-8 justify-center">
                      <div
                        class="input-item input-with-label form-group input-group"
                      >
                        <input
                          type="search"
                          v-model="searchParty"
                          style="border-right:0"
                          placeholder="Search by party name"
                          aria-describedby="button-addon1"
                          class="form-control bg-light"
                        />
                        <div class="input-group-append">
                          <button
                            type="submit"
                            style="border-radius:0px 3px 3px 0px;border-left:0px "
                            class="border bg-light px-2 py-0 text-primary btn-link"
                          >
                            <em class="fa fa-search"></em>
                          </button>
                        </div>
                      </div>
                      <div style="max-height:400px;overflow:auto;">
                        <ul
                          v-show="
                            data.partyName
                              .toLowerCase()
                              .startsWith(searchParty.toLowerCase())
                          "
                          style="border:3px solid blue;padding:6px;border-radius:8px;margin-top:0"
                          v-for="(data, index) in getPartyDetails"
                          :key="index"
                        >
                          <div
                            style="text-size:15px;color:gray;text-align:center"
                            class="mt-2"
                          >
                            <hr class="pa-0 ma-0" />
                            <p
                              style="top:0;margin:0;padding:0"
                              class="pa-0 ma-0"
                            >
                              {{ index + 1 }}
                            </p>
                            <hr />
                            <span>address: {{ data.partyAddress }}</span
                            ><br />
                            <span style="margin-left:20px;"
                              >Partner Name: {{ data.partyName }}</span
                            ><br />
                             <span style="margin-left:20px;"
                              >Total KYC count: {{ data.kycCount }}</span
                            ><br />
                            <span
                              v-if="data.special == true"
                              style="margin-left:20px;"
                              >Partner Type: Special</span
                            >
                            <span v-else style="margin-left:20px;"
                              >Partner Type: Normal</span
                            >
                            <br />

                            <button
                              @click="removeParty(data.partyName)"
                              class="btn btn-primary my-2"
                            >
                              Remove
                            </button>
                            <br />
                            <button
                              v-if="data.special == false"
                              @click="
                                addSpecial(data.partyName, data.partyAddress)
                              "
                              class="btn btn-primary my-2"
                            >
                              Make this party special
                            </button>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <h5>No Party available to remove</h5>
                  </div>
                </div>
              </div>
            </center>
            <hr style="border:0.5px solid blue;" />

            <center>
              <h4>Add a government</h4>

              <div class="row justify-center">
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Tron address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="govAddress"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Country
                      <span class="text-danger">*</span>
                    </label>

                    <select
                      class="form-control"
                      name="nationality"
                      v-model="country"
                      id="nationality"
                    >
                      <option value disabled selected
                        >Choose your option</option
                      >
                      <option
                        :value="data.name"
                        v-for="(data, index) in list"
                        :key="index"
                        >{{ data.name }}</option
                      >
                    </select>
                    <!-- <input
                      v-model="country"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    > -->
                  </div>
                </div>
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Email address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="govEmail"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6 justify-center">
                <div @click="addGov" class="btn btn-primary">Add</div>
              </div>
            </center>
            <hr style="border:0.5px solid blue;" />
            <center>
              <h4>Remove a government</h4>

              <div
                v-if="govDetails.length > 0"
                class="row justify-content-center"
              >
                <div class="col-md-12 col-lg-8 justify-center">
                  <div
                    class="input-item input-with-label form-group input-group"
                  >
                    <input
                      type="search"
                      v-model="searchCountry"
                      style="border-right:0"
                      placeholder="Search by country name"
                      aria-describedby="button-addon1"
                      class="form-control bg-light"
                    />
                    <div class="input-group-append">
                      <button
                        type="submit"
                        style="border-radius:0px 3px 3px 0px;border-left:0px "
                        class="border bg-light px-2 py-0 text-primary btn-link"
                      >
                        <em class="fa fa-search"></em>
                      </button>
                    </div>
                  </div>
                  <div style="max-height:250px;overflow:auto;">
                    <ul
                      v-show="
                        data.country
                          .toLowerCase()
                          .startsWith(searchCountry.toLowerCase())
                      "
                      style="border:3px solid blue;padding:6px;border-radius:8px;margin-top:0"
                      v-for="(data, index) in getGovDetails"
                      :key="index"
                    >
                      <div style="text-size:15px;color:gray;" class="mt-2">
                        <hr class="pa-0 ma-0" />
                        <p style="top:0;margin:0;padding:0" class="pa-0 ma-0">
                          {{ index + 1 }}
                        </p>
                        <hr />
                        <span>address: {{ data.address }}</span
                        ><br />
                        <span style="margin-left:20px;"
                          >Country: {{ data.country }}</span
                        >
                        <br />
                        <button
                          @click="removeGov(data.address)"
                          class="btn btn-primary my-2"
                        >
                          Remove
                        </button>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-else class="justify-center">
                <h5>No data available to display</h5>
              </div>
              <!-- <div class="col-md-6 justify-center">
                <div @click="removeGov" class="btn btn-primary">Remove</div>
              </div> -->
            </center>
            <hr style="border:0.5px solid blue;" />

            <center>
              <h4>Block/Unblock a user</h4>

              <div class="row justify-center">
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Tron address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="userAddress1"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                  <div @click="blockUser" class="btn btn-primary mb-2">
                    Block
                  </div>
                </div>

                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Tron address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="userAddress2"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                  <div @click="unblockUser" class="btn btn-primary">
                    Unblock
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-6 justify-center">
                <div class="btn btn-primary">Add</div>
              </div>-->
            </center>

            <hr style="border:0.5px solid blue;" />
            <center>
              <h4>Start/Stop cron</h4>
              <div class="row justify-center mt-4">
                <div class="col-md-6 justify-center">
                  <div @click="startCron" class="btn btn-primary mb-2">
                    Start
                  </div>
                </div>

                <div class="col-md-6 justify-center">
                  <div @click="stopCron" class="btn btn-primary">Stop</div>
                </div>
              </div>
            </center>
          </div>
        </div>
        <div
          v-else-if="isAdmin"
          style="max-height:60%;overflow:auto"
          class="card col-9 col-xs-10 p-3 mt-3"
        >
          <div
            class="card col-lg-8 col-md-8 col-sm-8 col-xl-8 col-xs-10 mx-auto"
          >
            <center>
              <h4>Block/Unblock a user</h4>

              <div class="row justify-center">
                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Tron address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="userAddress1"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                  <div @click="blockUser" class="btn btn-primary mb-2">
                    Block
                  </div>
                </div>

                <div class="col-md-6 justify-center">
                  <div class="input-item input-with-label form-group">
                    <label class="input-item-label">
                      Tron address
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      v-model="userAddress2"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.fname.$error }"
                      type="text"
                    />
                  </div>
                  <div @click="unblockUser" class="btn btn-primary">
                    Unblock
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-6 justify-center">
                <div class="btn btn-primary">Add</div>
              </div>-->
            </center>
          </div>
        </div>
      </center>
    </div>
    <div data-backdrop="false" class="modal fade" id="passwordModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Enter password to sign the transaction</h4>
            <button
              type="button"
              @click="
                pk = '';
                password = '';
              "
              class="close"
              data-dismiss="modal"
            >
              &times;
            </button>
          </div>

          <div class="modal-body">
            <div class="input-item input-with-label">
              <label class="input-item-label">
                Password
                <span class="text-danger">*</span>
              </label>
              <input
                v-model="password"
                class="input-bordered"
                type="password"
              />
            </div>
          </div>

          <div class="modal-footer">
            <button
              v-if="isAddAdmin"
              @click="addAdmin"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="isRemoveAdmin"
              @click="removeAdmin"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="isBlockUser"
              @click="blockUser"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="isUnblockUser"
              @click="unblockUser"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="isAddParty"
              @click="addParty"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="isRemoveParty"
              @click="removeParty"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="isAddGov"
              @click="addGov"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="isRemoveGov"
              @click="removeGov(removeGovAddress)"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
            <button
              v-else-if="makeSpecial"
              @click="addSpecial(partyName, partyAddress)"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {decrypt} from '../utils/crypto'

import axios from "axios";

export default {
  name: "Admin",
  data() {
    return {
      userCount: 0,
      makeParty: false,
      tokenPrice: 0,
      price: 0,
      id: "",
      web3: this.$store.state.web3,
      currentAddress: this.$cookies.get("address"),
      submitted: false,
      isAddParty: undefined,
      isRemoveParty: undefined,
      isAddAdmin: undefined,
      isRemoveAdmin: undefined,
      isAddGov: undefined,
      isRemoveGov: undefined,
      isBlockUser: undefined,
      isUnblockUser: undefined,
      password: "",
      selection: ["Normal", "Special"],
      partyType: "",
      partyEmail: "",
      govEmail: "",
      adminAddress1: "",
      adminAddress2: "",
      govDetails: [],
      govAddress: "",
      removeGovAddress: "",
      country: "",
      removePartyAddress: "",
      partyAddress: "",
      partyName: "",
      userAddress1: "",
      userAddress2: "",
      partyDetails: {
        address: "",
        city: "",
        zipCode: "",
        country: "",
      },
      parties: [],
      gov: undefined,
      list: [
        { name: "Afghanistan", code: "AF" },
        { name: "land Islands", code: "AX" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "American Samoa", code: "AS" },
        { name: "AndorrA", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Anguilla", code: "AI" },
        { name: "Antarctica", code: "AQ" },
        { name: "Antigua and Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Aruba", code: "AW" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bermuda", code: "BM" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Bosnia and Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Bouvet Island", code: "BV" },
        { name: "Brazil", code: "BR" },
        { name: "British Indian Ocean Territory", code: "IO" },
        { name: "Brunei Darussalam", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Cape Verde", code: "CV" },
        { name: "Cayman Islands", code: "KY" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Christmas Island", code: "CX" },
        { name: "Cocos (Keeling) Islands", code: "CC" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo", code: "CG" },
        { name: "Congo, The Democratic Republic of the", code: "CD" },
        { name: "Cook Islands", code: "CK" },
        { name: "Costa Rica", code: "CR" },
        { name: "Cote D'Ivoire", code: "CI" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Cyprus", code: "CY" },
        { name: "Czech Republic", code: "CZ" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Ethiopia", code: "ET" },
        { name: "Falkland Islands (Malvinas)", code: "FK" },
        { name: "Faroe Islands", code: "FO" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "French Guiana", code: "GF" },
        { name: "French Polynesia", code: "PF" },
        { name: "French Southern Territories", code: "TF" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Gibraltar", code: "GI" },
        { name: "Greece", code: "GR" },
        { name: "Greenland", code: "GL" },
        { name: "Grenada", code: "GD" },
        { name: "Guadeloupe", code: "GP" },
        { name: "Guam", code: "GU" },
        { name: "Guatemala", code: "GT" },
        { name: "Guernsey", code: "GG" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Heard Island and Mcdonald Islands", code: "HM" },
        { name: "Holy See (Vatican City State)", code: "VA" },
        { name: "Honduras", code: "HN" },
        { name: "Hong Kong", code: "HK" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran, Islamic Republic Of", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Isle of Man", code: "IM" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jersey", code: "JE" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: "Korea, Democratic People'S Republic of", code: "KP" },
        { name: "Korea, Republic of", code: "KR" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: "Lao People'S Democratic Republic", code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libyan Arab Jamahiriya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Macao", code: "MO" },
        { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Martinique", code: "MQ" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mayotte", code: "YT" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia, Federated States of", code: "FM" },
        { name: "Moldova, Republic of", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montenegro", code: "ME" },
        { name: "Montserrat", code: "MS" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "Netherlands Antilles", code: "AN" },
        { name: "New Caledonia", code: "NC" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "Niue", code: "NU" },
        { name: "Norfolk Island", code: "NF" },
        { name: "Northern Mariana Islands", code: "MP" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestinian Territory, Occupied", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Pitcairn", code: "PN" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Puerto Rico", code: "PR" },
        { name: "Qatar", code: "QA" },
        { name: "Reunion", code: "RE" },
        { name: "Romania", code: "RO" },
        { name: "Russian Federation", code: "RU" },
        { name: "RWANDA", code: "RW" },
        { name: "Saint Helena", code: "SH" },
        { name: "Saint Kitts and Nevis", code: "KN" },
        { name: "Saint Lucia", code: "LC" },
        { name: "Saint Pierre and Miquelon", code: "PM" },
        { name: "Saint Vincent and the Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "Sao Tome and Principe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia", code: "RS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Africa", code: "ZA" },
        { name: "South Georgia and the South Sandwich Islands", code: "GS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Svalbard and Jan Mayen", code: "SJ" },
        { name: "Swaziland", code: "SZ" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syrian Arab Republic", code: "SY" },
        { name: "Taiwan, Province of China", code: "TW" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania, United Republic of", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tokelau", code: "TK" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad and Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Turks and Caicos Islands", code: "TC" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States", code: "US" },
        { name: "United States Minor Outlying Islands", code: "UM" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Venezuela", code: "VE" },
        { name: "Viet Nam", code: "VN" },
        { name: "Virgin Islands, British", code: "VG" },
        { name: "Virgin Islands, U.S.", code: "VI" },
        { name: "Wallis and Futuna", code: "WF" },
        { name: "Western Sahara", code: "EH" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" },
      ],
      searchCountry: "",
      isAdmin: false,
      isOwner: false,
      pk: "",
      searchParty: "",
    };
  },
  asyncComputed: {
    async getGovDetails() {
      return this.govDetails.filter((data) => {
        return data.country
          .toLowerCase()
          .startsWith(this.searchCountry.toLowerCase());
      });
    },
    async getPartyDetails() {
      return this.parties.filter((data) => {
        return data.partyName
          .toLowerCase()
          .startsWith(this.searchParty.toLowerCase());
      });
    },
  },

  methods: {
    async addSpecial(partyName, partyAddress) {
      this.makeSpecial = true;
      if (this.partyName == "" && this.partyAddress == "") {
        this.partyName = partyName;
        this.partyAddress = partyAddress;
      }
      if (this.partyName != "") {
        if (this.password == "") {
          window
            .$("#passwordModal")
            .modal({ backdrop: "static", keyboard: false });
        }
        if (this.password != "") {
          try {
            this.$store.state.loading = true;
            await this.loginKeyStore();
            let isSpecial = undefined;

            let balance = await this.$store.state.Token.methods
              .balanceOf(this.partyAddress)
              .call();
            balance = await this.web3.utils.fromWei(
              balance.toString(),
              "ether"
            );
            balance = Number(balance);
            console.log(balance);

            if (balance * this.price >= 1000000) {
              isSpecial = true;
            } else {
              this.$toasted.global.my_app_error({
                message:
                  "The given partner doesn't have 1 million $ worth of Mima tokens",
              });
              this.$store.state.loading = false;
              return;
            }

            const encoded = await this.$store.state.KYC.addSpecialStatus(
              this.partyName
            ).encodeABI();

            const nonce = await this.web3.eth.getTransactionCount(
              this.currentAddress
            );
            const tx = {
              nonce: nonce,
              from: this.currentAddress.toString(),
              to: this.$store.state.KYC.address,
              data: encoded,
              gas: 2000000,
            };

            const signed = await this.web3.eth.accounts.signTransaction(
              tx,
              this.pk
            );
            this.web3.eth
              .sendSignedTransaction(signed.rawTransaction)
              .on("confirmation", (confirmationNumber, receipt) => {})
              .on("transactionHash", (hash) => {
                console.log("=> hash");
                console.log(hash);
              })
              .on("receipt", async (receipt) => {
                console.log("=> reciept");
                console.log(receipt.status);
                if (receipt.status == true) {
                  this.$store.state.loading = false;
                  this.$toasted.global.my_app_success({
                    message: "Transaction completed successfully",
                  });
                  window.location.reload();
                }
              })
              .on("error", (err) => {
                console.log("Error failed:", err);
                this.$store.state.loading = false;
                this.$toasted.global.my_app_error({
                  message: "Transaction failed",
                });
              });
          } catch (err) {
            console.log(err);
          } finally {
            this.partyName = "";
            this.partyAddress = "";
            this.$store.state.loading = false;
            this.makeSpecial = false;
          }
        }
      }
    },
    async updatePrice() {
      let key = process.env.VUE_APP_API_KEY;

      if (this.tokenPrice > 0) {
        this.$store.state.loading = true;
        try {
          await axios({
            url: this.$store.state.url + "/api/token_price/" + this.id,
            method: "PATCH",
            data: {
              tokenPrice: this.tokenPrice,
            },
            headers: {
              Authorization: "Basic " + key,
            },
          });
          this.$toasted.global.my_app_success({
            message: "Token price updated successfully",
          });
          this.price = this.tokenPrice;
        } catch (err) {
          console.log(err);
          this.$toasted.global.my_app_error({
            message: err.response.data.error,
          });
        } finally {
          this.$store.state.loading = false;
          this.tokenPrice = 0;
        }
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter token price",
        });
      }
    },
    async loginKeyStore() {
     // let result=false;
      if (localStorage.wallet) {
        //let result=false;
       try{

          //this.$store.state.loading = true;

             this.$store.state.loading = true;
            let wallet = localStorage.wallet;

            let pk=await decrypt(this.password,wallet);

            this.pk=pk.privateKey
             window.$("#passwordModal").modal("hide");






       }


          catch (err) {
            
            this.$store.state.loading = false;
            this.$toasted.global.my_app_error({
              message: "Please enter correct password"
            });
           throw err;

          } finally {
           // this.$store.state.loading = false;
            this.password=""
          }

      }


      else {
        this.$toasted.global.my_app_error({
          message: "Wallet is not available",
        });
      }
      //return result;

    },
    async addAdmin() {
      this.isAddAdmin = true;

      if (this.adminAddress1 != "") {
        let isAdmin = await this.$store.state.KYC.isAdmin(
          this.adminAddress1
        ).call();
        if (isAdmin == false) {
          if (this.password == "") {
            window
              .$("#passwordModal")
              .modal({ backdrop: "static", keyboard: false });
          }
           if (this.password != "") {
            try {
              this.$store.state.loading = true;
              await this.loginKeyStore();

               var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "address", value: this.adminAddress1 },


            ];

            // await this.$store.state.tronWeb.setPrivateKey(
            //  this.pk
            // );
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "addAdmin(address)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);


            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
                this.pk
            );
            console.group("Signed  transaction");

            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatus(tx.transaction.txID,false);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
               this.isBlockUser=false;
              }
            );
            } catch (err) {
              //this.isBlockUser=false
              this.$store.state.loading = false;
              console.log(err);
            } finally {
              // this.password = "";
              this.pk = "";

            }
          }
        } else {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "The given address is already added as an admin",
          });
        }
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter tron address",
        });
      }
    },
    async removeAdmin() {
      this.isRemoveAdmin = true;
      if (this.adminAddress2 != "") {
        let isAdmin = await this.$store.state.KYC.isAdmin(
          this.adminAddress2
        ).call();
        if (isAdmin == true) {
          if (this.password == "") {
            window
              .$("#passwordModal")
              .modal({ backdrop: "static", keyboard: false });
          }
            if (this.password != "") {
            try {
              this.$store.state.loading = true;
              await this.loginKeyStore();

               var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "address", value: this.adminAddress2 },


            ];

            await this.$store.state.tronWeb.setPrivateKey(
             this.pk
            );
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "removeAdmin(address)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);


            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
             this.pk
            );
            console.group("Signed  transaction");

            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatus(tx.transaction.txID,false);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
               this.isBlockUser=false;
              }
            );
            } catch (err) {
              //this.isBlockUser=false
              this.$store.state.loading = false;
              console.log(err);
            } finally {
              this.password = "";
              this.pk = "";

            }
          }
        } else {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "The given address is  not an admin",
          });
        }
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter tron address",
        });
      }
    },

    async blockUser() {
      this.isBlockUser = true;
      if (this.userAddress1 != "") {
        let isBlocked = await this.$store.state.KYC.blocked(
          this.userAddress1
        ).call();
        let kycDone = await this.$store.state.KYC.KYCDone(
          this.userAddress1
        ).call();
        if (isBlocked == false && kycDone) {
          if (this.password == "") {
            window
              .$("#passwordModal")
              .modal({ backdrop: "static" });
          }
          if (this.password != "") {
            try {
              this.$store.state.loading = true;
              await this.loginKeyStore();
             

               var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "address", value: this.userAddress1 },


            ];

            await this.$store.state.tronWeb.setPrivateKey(
             this.pk
            );
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "blockUser(address)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);


            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
             this.pk
            );
            console.group("Signed  transaction");

            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatus(tx.transaction.txID,false);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
               this.isBlockUser=false;
              }
            );
            } catch (err) {
              this.password=""
              //this.isBlockUser=false
              this.$store.state.loading = false;
              console.log(err);
            } finally {

              this.pk = "";

            }
          }
        } else {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message:
              "The given address is already bocked or has not completed KYC",
          });
        }
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter tron address",
        });
      }
    },
    async unblockUser() {
      this.isUnblockUser = true;
      if (this.userAddress2 != "") {
        console.log(this.userAddress2)
        let isBlocked = await this.$store.state.KYC.blocked(
          this.userAddress2
        ).call();
        let kycDone = await this.$store.state.KYC.KYCDone(
          this.userAddress2
        ).call();
        if (isBlocked && kycDone) {
          if (this.password == "") {
            window
              .$("#passwordModal")
              .modal({ backdrop: "static", keyboard: false });
          }
         if (this.password != "") {
            try {
              this.$store.state.loading = true;
             
             await this.loginKeyStore();
            
              // alert(result)
              // if(result==false) return;
               var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "address", value: this.userAddress2 },


            ];

            await this.$store.state.tronWeb.setPrivateKey(
              this.pk
            );
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "unblockUser(address)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);


            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
             this.pk
            );
            console.group("Signed  transaction");

            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatus(tx.transaction.txID,false);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
                 this.isUnblockUser = false;
              }
            );
            } catch (err) {
              this.password=""
              this.$store.state.loading = false;
               //this.is = false;
              console.log(err);
            } finally {
              //this.password = "";
              // this.pk = "";

            }
          }
        } else {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message:
              "The given address is not blocked or has not completed KYC",
          });
        }
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter tron address",
        });
      }
    },
    async addGov() {
      this.isAddGov = true;
      if (this.govAddress != "" && this.govEmail != "" && this.country != "") {
        let isGov = await this.$store.state.KYC.isGov(this.govAddress).call();
     
        if (isGov == false) {
           if (this.password == "") {
            window
              .$("#passwordModal")
              .modal({ backdrop: "static", keyboard: false });
          }
          if(this.password!=""){
          try {
            this.$store.state.loading = true;
            await this.loginKeyStore();
               this.govEmail=this.govEmail.toLowerCase();
                  let key = process.env.VUE_APP_API_KEY;
          let getData = await axios({
            url: this.$store.state.url+"/api/user/setVal",

            method: "POST",
            data: {
              val:this.govEmail
            },
            headers: {
              Authorization: "Basic " + key
            }
          });
          let encEmail=getData.data.val;
        let isEmail= await this.$store.state.KYC.getUserAddress(
       encEmail
        ).call();
          if(isEmail!="410000000000000000000000000000000000000000")
          {
             this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "The given email address is already in use",
          });
            return;
          }

            var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "address", value: this.govAddress },
              { type: "string", value: this.country },
              { type: "string", value: this.govEmail },
            ];

            
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "addToGov(address,string,string)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);
            // .then(res => {
            //   console.log(res)
            // })
            // .catch(err => {
            //   console.log(err)
            // })
            // async (err, transaction) => {
            //   if (err) return console.error(err)

            //   console.group('Unsigned trigger smart contract transaction')
            //   // console.log('- Contract Address: TA2x74755e7UZXGHWbw4CP1FZbEVvpFP9m')
            //   console.log(
            //     '- Transaction:\n' + JSON.stringify(transaction, null, 2),
            //     '\n'
            //   )
            //   console.groupEnd()
            // }

            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
             this.pk
            );
            console.group("Signed  transaction");
            // console.log(
            //   '- Transaction:\n' + JSON.stringify(signedTransaction, null, 2),
            //   '\n'
            // )
            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatus(tx.transaction.txID,false);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
              }
            );
          } catch (err) {
            console.log(err);
            this.$store.state.loading = false;
          }
          }
        } else {
          this.$toasted.global.my_app_error({
            message: "The given address is already registered as a government",
          });
        }
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter all the details",
        });
      }
    },

    async checkStatus(id,data) {
      let vm = this;
      let timer = setInterval(async () => {
        let info = await vm.$store.state.tronWeb.trx.getTransactionInfo(id);
        console.log(info);
        if (info.receipt.result == "SUCCESS") {
         clearInterval(timer);

          if(data){
              try {

                  console.log(info);
                      let key = process.env.VUE_APP_API_KEY;

                      let done = await axios({
                        url: this.$store.state.url + "/api/party",
                        method: "POST",
                        headers: {
                          Authorization: "Basic " + key,
                        },
                        data: {
                          email: this.partyEmail.trim(),
                          trxAddress: this.partyAddress.trim(),
                          partyName: this.partyName.trim(),
                          address: this.partyDetails.address.trim(),
                          city: this.partyDetails.city.trim(),
                          zipCode: this.partyDetails.zipCode.trim(),
                          country: this.partyDetails.country.trim(),
                        },
                      });
                this.$toasted.global.my_app_success({
                message: "Transaction completed",
              });
              }
              catch(err){
                console.log("Error:",err.response.message);
              }
              finally{
                  this.$store.state.loading = false;
              }

          }
          else{
            this.$store.state.loading=false;
            this.$toasted.global.my_app_success({
                message: "Transaction completed",
              });
          }


         setTimeout(function(){
            window.location.reload();
         },1500)
        } else if (info.result == "FAILED") {
            clearInterval(timer);
          this.$store.state.loading = false;
          console.log(info);
          this.$toasted.global.my_app_error({
            message: "Transaction failed",
          });

        }
      }, 1000);
    },

    async addParty() {
      this.isAddParty = true;
      if (
        this.partyAddress != "" &&
        this.partyEmail != "" &&
        this.partyName != "" &&
        this.partyDetails.address != "" &&
        this.partyDetails.city != "" &&
        this.partyDetails.zipCode != "" &&
        this.partyDetails.country != "" &&
        this.partyType != ""
      )
      {
        let isParty = await this.$store.state.KYC.isParty(
          this.partyAddress
        ).call();
       
        if (isParty == false ) {
           if (this.password == "") {
            window
              .$("#passwordModal")
              .modal({ backdrop: "static", keyboard: false });
          }
         else if (this.password != "") {

            try {
             
                
            this.$store.state.loading = true;
            
             await this.loginKeyStore();
              this.partyEmail=this.partyEmail.toLowerCase();
                let key = process.env.VUE_APP_API_KEY;
          let getData = await axios({
            url: this.$store.state.url+"/api/user/setVal",

            method: "POST",
            data: {
              val:this.partyEmail
            },
            headers: {
              Authorization: "Basic " + key
            }
          });
          let encEmail=getData.data.val
          let isEmail= await this.$store.state.KYC.getUserAddress(
        encEmail
          ).call();
            if(isEmail!="410000000000000000000000000000000000000000")
            {
              this.$store.state.loading = false;
            this.$toasted.global.my_app_error({
              message: "The given email address is already in use",
            });
              return;
            }
             let isSpecial;
            if (this.partyType == "Normal") {
                isSpecial = false;
              } else if (this.partyType == "Special") {
                let balance = await this.$store.state.Token
                  .balanceOf(this.partyAddress)
                  .call();
                balance = await this.$store.state.tronWeb.fromSun(
                  balance.toString(),

                );
                balance = Number(balance);
                console.log(balance);

                if (balance * this.price >= 1000000) {
                  isSpecial = true;
                } else {
                  this.$toasted.global.my_app_error({
                    message:
                      "The given partner doesn't have 1 million $ worth of Mima tokens",
                  });
                  this.$store.state.loading = false;
                  return;
                }
              }
            //this.partyType=this.partyType=="Normal"?false:true;

            var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "address", value: this.partyAddress.trim() },
              { type: "string", value: this.partyName.trim() },
              { type: "string", value: this.partyEmail.trim() },
               { type: "bool", value: isSpecial },

            ];

           
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "addToParty(address,string,string,bool)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);


            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
              this.pk
            );
            console.group("Signed  transaction");

            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatus(tx.transaction.txID,true);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
              }
            );

            }
           catch (err) {
            console.log(err);
            this.$store.state.loading = false;
          }finally {
              this.password = "";
              // this.pk = "";
             // this.isAddParty = false;
            }
          }
        }
         else {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "The given address is already registered as a party",
          });
        }
      }

       else {
        this.$toasted.global.my_app_error({
          message: "Please enter all the details",
        });
      }
    },

 async checkStatusRemoveParty(id) {
      let vm = this;
      let timer = setInterval(async () => {
        let info = await vm.$store.state.tronWeb.trx.getTransactionInfo(id);
        console.log(info);
        if (info.receipt.result == "SUCCESS") {
         clearInterval(timer);
              try {

                  console.log(info);
                      let key = process.env.VUE_APP_API_KEY;

                      let done = await axios({
                        url: this.$store.state.url + "/api/party?partyName="+this.partyName,
                        method: "DELETE",
                        headers: {
                          Authorization: "Basic " + key,
                        },
                        
                      });
                this.$toasted.global.my_app_success({
                message: "Transaction completed",
              });
              }
              catch(err){
                console.log(err);
              }
              finally{
                  this.$store.state.loading = false;
              }

         setTimeout(function(){
            window.location.reload();
         },1500)
        } else if (info.result == "FAILED") {
            clearInterval(timer);
          this.$store.state.loading = false;
          console.log(info);
          this.$toasted.global.my_app_error({
            message: "Transaction failed",
          });

        }
      }, 1000);
    },


    async removeParty(partyName) {
      this.isRemoveParty = true;
      if (partyName != "") {
        if (this.partyName == "") {
          this.partyName = partyName;
        }
        if (this.password == "") {
          window
            .$("#passwordModal")
            .modal({ backdrop: "static", keyboard: false });
        }
            if (this.password != "") {
            try {
              this.$store.state.loading = true;
             
             await this.loginKeyStore();
            
              // alert(result)
              // if(result==false) return;
               var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "string", value: this.partyName},


            ];

            await this.$store.state.tronWeb.setPrivateKey(
              this.pk
            );
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "removeParty(string)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);


            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
             this.pk
            );
            console.group("Signed  transaction");

            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatusRemoveParty(tx.transaction.txID);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
                 this.isUnblockUser = false;
              }
            );
            } catch (err) {
              this.password=""
              this.$store.state.loading = false;
               //this.is = false;
              console.log(err);
            } finally {
              //this.password = "";
              // this.pk = "";

            }
          }
        
       
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter tron address",
        });
      }
    },
    async removeGov(address) {
      this.isRemoveGov = true;
      if (this.removeGovAddress == "") {
        this.removeGovAddress = address;
      }

      if (this.removeGovAddress != "") {
        let isGov = await this.$store.state.KYC.isGov(
          this.removeGovAddress
        ).call();

        if (isGov) {
          if (this.password == "") {
            window
              .$("#passwordModal")
              .modal({ backdrop: "static", keyboard: false });
          }
            if (this.password != "") {
            try {
              this.$store.state.loading = true;
             
             await this.loginKeyStore();
            
              // alert(result)
              // if(result==false) return;
               var options = {
              feeLimit: 20000000,
              callValue: 0,
              // tokenValue:10,
              // tokenId:1000001
            };
            let params = [
              { type: "address", value: this.removeGovAddress },


            ];

            await this.$store.state.tronWeb.setPrivateKey(
              this.pk
            );
            let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
              this.$store.state.tronWeb.address.toHex(
                this.$store.state.address
              ),
              "removeGov(address)",
              options,
              params,
              this.$store.state.tronWeb.address.toHex(this.currentAddress)
            );
            console.log("transacion:", tx);


            const signedTransaction = await this.$store.state.tronWeb.trx.sign(
              tx.transaction,
             this.pk
            );
            console.group("Signed  transaction");

            console.groupEnd();

            await this.$store.state.tronWeb.trx.sendRawTransaction(
              signedTransaction,
              async (err, result) => {
                if (err) {
                  console.error(err);
                }

                console.group("Broadcast transaction");
                console.log(
                  "- Result:\n" + JSON.stringify(result, null, 2),
                  "\n"
                );
                console.log(tx.transaction.txID);
                await this.checkStatus(tx.transaction.txID,false);
                //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
                //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

                console.groupEnd();
                 this.isUnblockUser = false;
              }
            );
            } catch (err) {
              this.password=""
              this.$store.state.loading = false;
               //this.is = false;
              console.log(err);
            } finally {
              //this.password = "";
              // this.pk = "";

            }
          }
        
        } else {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "The given address is not registered as a government",
          });
        }
      } else {
        this.$toasted.global.my_app_error({
          message: "Please enter tron address",
        });
      }
    },
    async getParties(partyName, partyAddress, isSpecial,timestamp) {
      try {
        let isParty = await this.$store.state.KYC.isParty(partyAddress).call();
        console.log(partyName)
        if (isParty == true) {
          let data = await this.$store.state.tronWeb.event.getEventsByContractAddress(
        this.$store.state.address,
        { eventName: "addedParty",since:timestamp,size:200, filters: {partyName:partyName} }
      );
      let partyDetails=await this.$store.state.KYC.getPartyDetails().call({from:partyAddress});
      let count=parseInt(await await this.$store.state.KYC.kycCount(partyAddress).call());

      // console.log(data)
      // data=data[data.length-1];
      // console.log("new" ,data)
          // data = data[data.length - 1];
          // let partyDetails = await this.$store.state.KYC.getPartyDetails().call(
          //   { from: partyAddress }
          // );
          this.parties.push({
            partyName: partyDetails.partyName,
            partyAddress:this.$store.state.tronWeb.address.fromHex(partyAddress),
            special: partyDetails.isSpecial,
            kycCount:count
          });
          this.parties = await [
            ...new Map(
              await this.parties.map((item) => [item["partyAddress"], item])
            ).values(),
          ];
          console.log("added");
          
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGov(country, govAddress) {
      try {
        //let len = await this.$store.state.KYC.getGovLen().call();
      //  console.log("India:", this.$store.state.tronWeb.sha3("India"));
        let arr = [];
        let isGov = await this.$store.state.KYC.isGov(govAddress).call();
        console.log("is gov:", isGov);
        if (isGov) {
          this.govDetails.push({ country: country, address: govAddress });
          this.govDetails = await [
            ...new Map(
              await this.govDetails.map((item) => [item["address"], item])
            ).values(),
          ];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async startCron() {
      let key = process.env.VUE_APP_API_KEY;

      try {
        let done = await axios({
          url: this.$store.state.url + "/api/user/startCron",
          method: "POST",

          headers: {
            Authorization: "Basic " + key,
          },
          withCredentials: true,
        });

        this.$toasted.global.my_app_success({
          message: done.data.msg,
        });
      } catch (err) {
        this.$toasted.global.my_app_error({
          message: err.data.error,
        });
      }
    },
    async stopCron() {
      let key = process.env.VUE_APP_API_KEY;

      try {
        let done = await axios({
          url: this.$store.state.url + "/api/user/stopCron",
          method: "POST",

          headers: {
            Authorization: "Basic " + key,
          },
          withCredentials: true,
        });

        this.$toasted.global.my_app_success({
          message: done.data.msg,
        });
      } catch (err) {
        this.$toasted.global.my_app_error({
          message: err.data.error,
        });
      }
    },
    async checkIdentity() {
      let owner = await this.$store.state.KYC.Owner().call();
      // console.log(owner);
      owner = await this.$store.state.tronWeb.address.fromHex(owner);
      //  let owner2 = await this.$store.state.KYC.Owner2().call();
      let admin = await this.$store.state.KYC.isAdmin(
        this.currentAddress
      ).call();
      if (owner == this.currentAddress) {
        this.isOwner = true;
      } else if (admin == true) {
        this.isAdmin = true;
      }
    },
  },

  async created() {
    this.$store.state.loading = true;
    await this.$store.dispatch("setContract");
    this.userCount=await this.$store.state.KYC.totalUsers().call();


    await this.checkIdentity();

    let add=this.$store.state.tronWeb.address.toHex(this.currentAddress);
    add='0x'+add;
    let newAdd=this.$store.state.tronWeb.sha3(add);
    console.log("sha3:",newAdd);
    if (this.isOwner) {
      // var partyEvent = await this.$store.state.KYC.events.addedParty(
      //   {},
      //   { fromBlock: 0, toBlock: "latest" },
      //   async (error, result) => {
      //     if (result) {
      //       console.log(result);
      //       await this.getParties(
      //         result.returnValues.partyName,
      //         result.returnValues.party,
      //         result.returnValues.isSpecial
      //       );
      //       await this.$store.dispatch(
      //         "getCurrentBalance",
      //         this.currentAddress
      //       );
      //     } else {
      //       console.log(error);
      //     }
      //   }
      // );

      // var partyRemoved = await this.$store.state.KYC.events.partyRemoved(
      //   {},
      //   { fromBlock: "latest" },
      //   async (error, result) => {
      //     if (result) {
      //       console.log(result);
      //       var removeIndex = this.parties
      //         .map(function(item) {
      //           return item.partyAddress;
      //         })
      //         .indexOf(result.returnValues.party);
      //       console.log(removeIndex);
      //       // remove object
      //       if (removeIndex != -1) {
      //         this.parties.splice(removeIndex, 1);
      //       }
      //       //await this.getParties(result.returnValues.partyName,result.returnValues.party)
      //       await this.$store.dispatch(
      //         "getCurrentBalance",
      //         this.currentAddress
      //       );
      //     } else {
      //       console.log(error);
      //     }
      //   }
      // );
      let govEvents = await this.$store.state.tronWeb.event.getEventsByContractAddress(
        this.$store.state.address,
        { eventName: "addedGov", start: 1, filters: {} }
      );
      console.log(govEvents);
      govEvents = govEvents.reverse();
      for (let i = 0; i < govEvents.length; i++) {
        await this.getGov(
          govEvents[i].result.country,
          this.$store.state.tronWeb.address.fromHex(govEvents[i].result.gov)
        );
      }


       let partyEvents = await this.$store.state.tronWeb.event.getEventsByContractAddress(
        this.$store.state.address,
        { eventName: "addedParty", start: 1, filters: {} }
      );
      console.log(partyEvents);
      partyEvents = partyEvents.reverse();
      for (let i = 0; i < partyEvents.length; i++) {
        await this.getParties(
          partyEvents[i].result.partyName,

          this.$store.state.tronWeb.address.fromHex(partyEvents[i].result.party),

          partyEvents[i].result.isSpecial,
          partyEvents[i].block_timestamp
        );
      }
      // var govEvent = await this.$store.state.KYC.events.addedGov(
      //   {},
      //   { fromBlock: 0, toBlock: "latest" },
      //   async (error, result) => {
      //     if (result) {
      //       console.log(result);

      //       await this.getGov(
      //         result.returnValues.country,
      //         result.returnValues.gov
      //       );
      //       await this.$store.dispatch(
      //         "getCurrentBalance",
      //         this.currentAddress
      //       );
      //     } else {
      //       console.log(error);
      //     }
      //   }
      // );

      // var govRemoved = await this.$store.state.KYC.events.govRemoved(
      //   {},
      //   { fromBlock: "latest" },
      //   async (error, result) => {
      //     if (result) {
      //       var removeIndex = this.govDetails
      //         .map(function(item) {
      //           return item.address;
      //         })
      //         .indexOf(result.returnValues.gov);

      //       // remove object
      //       if (removeIndex != -1) {
      //         this.govDetails.splice(removeIndex, 1);
      //       }
      //       await this.$store.dispatch(
      //         "getCurrentBalance",
      //         this.currentAddress
      //       );
      //     } else {
      //       console.log(error);
      //     }
      //   }
      // );

      let key = process.env.VUE_APP_API_KEY;

      try {
        let price = await axios({
          url: this.$store.state.url + "/api/token_price",
          method: "GET",
          headers: {
            Authorization: "Basic " + key,
          },
        });
        this.price = price.data.data.tokenPrices[0].tokenPrice;
        this.id = price.data.data.tokenPrices[0]._id;
        console.log(this.id);
        console.log(price);
      } catch (err) {
        console.log(err);
      }
      await this.$store.dispatch("getCurrentBalance", this.currentAddress);
      this.$store.state.loading = false;
    }



    // this.$store.state.KYC.addedGov().watch((err,res)=>{
    //     if(err) console.log(err)
    //     if(res){
    //         console.log("Event:",res);
    //     alert("Added")

    //     window.location.reload()
    //     }
    // })
    // let data = await this.$store.state.KYC.getPastEvents("countryAdded", {
    //   fromBlock: 0,
    //   toBlock: "latest",
    // });
    // let data = [];
    // this.userCount = data.length;
    // console.log("Total users:", data.length);

    await this.$store.dispatch("getCurrentBalance", this.currentAddress);
    this.$store.state.loading = false;
  },
};
</script>
<style scoped>
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";
@import url("https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/css/toastr.min.css");
#myModal {
  top: 10%;

  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10040;
  overflow: auto;
  overflow-y: auto;
}
</style>
